<div
  class="header h-[55px] flex justify-start items-center pl-[50px] !bg-[#F1F3F5] overflow-y-hidden sticky !z-20 top-0"
>
  <p class="!m-0 text-[18px]">
    {{ projectName }} - Initiate Expression Of Interest
  </p>
  <p
    class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
  >
    Select Companies
  </p>
</div>
<div class="!w-full overflow-y-hidden">
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 !mb-[5px]"
  >
    <div class="mt-[0px] m-[0px] pt-[12px] wrapper">
      <mat-form-field
        appearance="outline"
        class="custom-mat-form-field !rounded-2xl !w-[429px] !mb-[5px]"
      >
      <mat-label>Select Company </mat-label>
        <!-- TODO: formControl and value can be merged into one. no need for both -->
        <mat-select
          [formControl]="selectedReceiverOrganizationControl"
          [value]="selectedReceiverOrganization"
          placeholder="Select Company"
          style="font-size: 14px !important"
          (selectionChange)="setCurrentReceiverOrganization()"
          class="mat-form-field"
        >
          <!-- Custom Search Input Inside the Mat-Select Dropdown -->
          <div class="search-container" mat-select-header>
            <div class="relative flex">
              <input
                type="text"
                placeholder="Search "
                [(ngModel)]="searchTerm"
                (input)="filterOrganizationsInDDL()"
                class="search-input"
              />
              <img
                class="absolute right-[15px] mt-[20px] transform -translate-y-[50%] w-[1.1rem] h-[1.1rem] rounded-full"
                src="assets/icons/search.svg"
                alt="message icon"
              />
            </div>
          </div>
          <!-- Organization Options -->
          <mat-option
            (click)="externalOrgOptionSelection()"
            [value]="'other'"
            class="hover:!bg-[#fae8e1] font-semibold !border-t"
            >External Company</mat-option
          >
          <ng-container *ngFor="let org of filteredOrganizations" >
            <mat-option
              [value]="org"
              (click)="fetchReceiverOrganizationEOIDetails(org)"
              class="!border-t"
            >
              {{ org?.name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-error
        *ngIf="
          selectedReceiverOrganizationControl.invalid &&
          selectedReceiverOrganizationControl.touched
        "
      >
      Company inclusion is required.
      </mat-error>
    </div>

    <!-- NOTE: (blur) listens for the blur event, which is triggered when the input loses focus -->
    <!-- (keydown.enter)="fetchReceiverOrganizationEOIDetails('')" -->
    <div *ngIf="isExternalOrg" class="!pt-[12px]">
      <div class="rounded p-0 !pb-0 !pt-0 !mb-[10px]">
        <mat-form-field class="!w-[429px] !mb-[5px]" appearance="outline">
          <mat-label> Company Name </mat-label>
          <input
            matInput
            [formControl]="externalOrgNameControl"
            placeholder="Company Name"
            (blur)="fetchReceiverOrganizationEOIDetails('')"
            (keydown)="removeOrFetchExternalCompanyDetails($event)"
          />
        </mat-form-field>
        <mat-error
          *ngIf="
            externalOrgNameControl.invalid && externalOrgNameControl.touched
          "
        >
          External company name is required.
        </mat-error>
      </div>
    </div>
  </div>

  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0 !mb-[10px]">
        <mat-form-field class="!w-[429px] !mb-[5px]" appearance="outline">
          <mat-label> Name </mat-label>
          <input matInput [formControl]="nameControl" placeholder="Name" />
        </mat-form-field>
        <mat-error *ngIf="nameControl.invalid && nameControl.touched">
          Name is required.
        </mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0 !mb-[10px]">
        <mat-form-field class="!w-[429px] !mb-[5px]" appearance="outline">
          <mat-label> Email </mat-label>
          <input matInput [formControl]="emailControl" placeholder="Email" />
        </mat-form-field>
        <mat-error *ngIf="emailControl.invalid && emailControl.touched">
          Email is required.
        </mat-error>
      </div>
    </div>
  </div>
  <div
    class="!pl-[20px] !ml-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
  >
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0 !mb-[10px]">
        <mat-form-field class="!w-[429px] !mb-[5px]" appearance="outline">
          <mat-label> Position </mat-label>
          <input
            matInput
            [formControl]="positionControl"
            placeholder="Position"
          />
        </mat-form-field>
        <mat-error *ngIf="positionControl.invalid && positionControl.touched">
          Position is required.
        </mat-error>
      </div>
    </div>
  </div>
</div>
<div
  class="!pl-[20px] !ml-[30px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
>
  <div class="!w-[429px] flex justify-end items-center">
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="addReceiverOrganizationDetails()"
    >
      Add
    </button>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div
    class="!w-[100%] flex"
    style="max-height: calc(40vh - 170px); overflow-y: auto; overflow-x: hidden"
  >
    <table
      class="!w-[100%] bg-[#fcfcfd] table-auto !ml-[50px]"
      style="margin-right: 0px"
    >
      <thead
        class="h-[52px] bg-[#DEE2E6] text-[#343A40] !text-center justify-center !p-[20px] sticky-company-header top-0 z-20"
      >
        <tr>
          <th class="px-4 py-2 text-left w-[345px]">Company</th>
          <th class="px-4 py-2 text-left w-auto">Name</th>
          <th class="px-4 py-2 text-left w-auto">Email</th>
          <th class="px-4 py-2 text-left w-auto">Position</th>
          <th class="px-4 py-2 text-center w-auto">Action</th>
        </tr>
      </thead>
      <tbody>
        <ng-container>
          <tr
            *ngFor="let orgDetail of receiverOrganizationsList; let i = index"
            class="hover:bg-[#fae8e1] border-b-0 items-center justify-center"
            [ngClass]="{
              'bg-white': i % 2 === 0,
              'bg-[#DEE2E6]': i % 2 !== 0
            }"
          >
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.company_name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.name }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.email }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-left">
              {{ orgDetail.position }}
            </td>
            <td class="border-b-0 px-4 py-2 w-auto text-center cursor-pointer">
              <mat-icon>more_vert</mat-icon>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<div
  class="!pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
    <button (click)="handleBack()" type="button" class="back-btn">Back</button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
      (click)="moveToStep3()"
    >
      Next
    </button>
  </div>
</div>
